import { render, staticRenderFns } from "./timeout-order-detail.vue?vue&type=template&id=f2faf9b8&scoped=true&"
import script from "./timeout-order-detail.vue?vue&type=script&lang=js&"
export * from "./timeout-order-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2faf9b8",
  null
  
)

export default component.exports